import React, { Component } from 'react';
import { connect } from 'react-redux'
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { Grid, MenuItem } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import ImageUploader from 'react-images-upload';
import CancelIcon from '@material-ui/icons/Cancel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import axios from '../../http-config'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
// import MenuItem from "@material-ui/core/MenuItem";
// import FormControl from "@material-ui/core/FormControl";
// import Select from "@material-ui/core/Select";
import { withStyles } from '@material-ui/core/styles';
import swal from 'sweetalert';
import { el, id } from 'date-fns/locale';
import { withTranslation } from 'react-i18next';
class ClusterForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: !!this.props && !!this.props.ULBId ? this.props.ULBId : '',
            tfaId: this.props.tfaId ? this.props.tfaId : '',
            ClusterulbName: !!this.props && !!this.props.clusterUlbName ? this.props.clusterUlbName : '',
            ClusterulbName_tm: !!this.props && !!this.props.clusterUlbName_tn ? this.props.clusterUlbName_tn : '',
            typeId: this.props.typeId ? this.props.typeId : "",
            ClusterulbNameErr: '',
            ulbnameErr: '',
            ulbname: this.props ? this.props.ULBId : false,
            // TfNameErr: '',
            ulbOptions: [],
            tfOption: [],
            TfName: this.props.tfId ? this.props.tfId : "",
            StatusValue: !!this.props.isDisableULB ? !!this.props.isDisableULB && this.props.isDisableULB === "In Active" ? true : false : '',
            isStatus: null,
            AllSelectedUlb: [],
            AllremovedTf: [],
            tfList: [],
            selectedTable: [],
            AllSelectedTf: [],
            selectedTableTf: [],
            data:{}

        }
    }
    componentDidMount() {
        // axios({
        //     method: 'get',
        //     url: `ulb?tfULB=true`,
        //     headers: { 'Authorization': `Bearer ${this.props.token}` }
        // })
        //     .then((response) => {
        //         this.setState({ ulbOptions: response.data.data.ulbs })
        //     })

        // if (this.state.ulbname !== '') {
        //     axios({
        //         method: 'get',
        //         url: `treatment_facility/ulb/${this.state.ulbname}`,
        //         headers: { 'Authorization': `Bearer ${this.props.token}` }
        //     })
        //         .then((response) => {
        //             this.setState({ tfOption: response.data.data })
        //         })
        // }
    }
    handleChange = (event) => {
        // if (event.target.name === 'ulbname') {

        //     axios({
        //         method: 'get',
        //         url: `treatment_facility/ulb/${event.target.value}`,
        //         headers: { 'Authorization': `Bearer ${this.props.token}` }
        //     })
        //         .then((response) => {
        //             this.setState({ tfOption: response.data.data })
        //         })
        // }
        // if (event.target.name === 'TfName') {
        //     this.state.tfList.push(event.target.value)
        // }


        this.setState({ [event.target.name]: event.target.value })

    }
    handleSubmit = (e) => {
        e.preventDefault()
        const err = this.checkValidity()
        if (!err) {
            const formdata = new FormData()
            let token = this.props.token
            for (let i = 0; i < this.state.tfList.length; i++) {
                formdata.append("tfIdList[]", this.state.tfList[i])

            }
            this.props.id && formdata.append("id", this.props.clusterUlbId)
            formdata.append("typeId", this.state.typeId)
            formdata.append("tfaId", this.state.tfaId)
            formdata.append("tfId", this.state.TfName)
            formdata.append("name", this.state.ClusterulbName)
            formdata.append("name_tn", this.state.ClusterulbName_tm)
            formdata.append("isDisableULB", this.state.StatusValue)
            // console.log("isDisableULB", formdata.get("isDisableULB"));
            let SubmitProp = this.props
            this.props.handleSubmit(formdata, SubmitProp)
        }


    }
    checkValidity = () => {
        const {t, i18n} = this.props
        let isError = false
        if (!this.state.ClusterulbName) {
            isError = true
            this.setState({ ClusterulbNameErr: `${t("required")}` })
        }
        else if ((this.state.ClusterulbName.length > 0 && this.state.ClusterulbName.length < 3) || (this.state.ClusterulbName.length > 100)) {
            isError = true
            this.setState({ ClusterulbNameErr: `${t("ulbnameErr")}` })
        }
        else if (this.state.ClusterulbName && this.state.ClusterulbName.length >= 3) {
            this.setState({ ClusterulbNameErr: '' })
        }

        // if (this.state.ulbname == undefined) {
        //     isError = true
        //     this.setState({ ulbnameErr: '*This field is required' })
        // }
        // else if (this.state.ulbname != undefined) {
        //     isError = false
        //     this.setState({ ulbnameErr: '' })
        // }

        // if (this.state.TfName == undefined) {
        //     isError = true
        //     this.setState({ TfNameErr: '*This field is required' })
        // }
        // else if (this.state.TfName !== undefined) {
        //     isError = false
        //     this.setState({ TfNameErr: '' })
        // }
        return isError
    }

    handlChangeStatus = (e) => {
        this.setState({ isStatus: e.target.value, StatusValue: e.target.value })
    }

    handleChecked = (e) => {
        if (e.target.checked == true) {
            this.state.AllSelectedUlb.push(e.target.value)
            // this.state.data["ulb"] =e.target.name
            // this.state.selectedTable.push(this.state.data)
            axios({
                method: 'get',
                url: `treatment_facility/ulb/${e.target.value}`,
                headers: { 'Authorization': `Bearer ${this.props.token}` }
            })
                .then((response) => {
                    this.setState({ tfOption: response.data.data })
                })

        }
        if (e.target.checked == false) {
            this.state.AllremovedTf.push(e.target.value)
        }
        this.setState({ [e.target.name]: e.target.checked })

    }
    // handleCheckedTfName = (e) => {
    //     if (e.target.checked == true) {
    //         this.state.AllSelectedTf.push(e.target.value)
       
       
    //     }

    // }
    render() {
        const {t, i18n} = this.props
        return (
            <div>
                <div className="create_ulb_content_outer">
                    <div className="create_ulb_content">
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <FormControl>
                                    <label className="required" htmlFor="ClusterulbName">{t("clusterUlbName")}</label>
                                    <TextField id="ClusterulbName"
                                        variant="outlined"
                                        placeholder={t("phclusterUlbName")}
                                        name="ClusterulbName"
                                        value={this.state.ClusterulbName}
                                        onChange={this.handleChange} />
                                    <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.ClusterulbNameErr}</div>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl>
                                    <label htmlFor="ulbName_tm">{t("clusterUlbNameTamil")}</label>
                                    <TextField id="ulbName_tm"
                                        variant="outlined"
                                        placeholder="క్లస్టర్ ULB పేరును నమోదు చేయండి"
                                        name="ClusterulbName_tm"
                                        value={this.state.ClusterulbName_tm}
                                        onChange={this.handleChange} />
                                </FormControl>
                            </Grid>

                            {/* <Grid item xs={6}>
                                <FormControl>
                                    <label className="required" htmlFor="ulbname">ULB Name</label>

                                    {!!this.props && this.props.id ? <>   <Select value={this.state.ulbname}
                                        onChange={this.handleChange}
                                        name="ulbname"
                                    >
                                        {this.state.ulbOptions.map((ulb) => {
                                            return (
                                                <MenuItem value={ulb.tfULBIId}>{ulb.Name}</MenuItem>
                                            )
                                        }
                                        )}
                                    </Select>
                                        <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.ulbnameErr}</div> </> : <div className="scrollPrentClu">
                                        {!!this.state.ulbOptions && this.state.ulbOptions.map((ulb) => {
                                            return (

                                                <FormControlLabel
                                                    control={<Checkbox style={{ color: 'green', fontFamily: 'Open sans-serif' }}
                                                        value={ulb.tfULBIId} checked={this.state.ulbname} onChange={this.handleChecked} name={ulb.Name} />}
                                                    label={ulb.Name}
                                                />
                                            )
                                        }
                                        )}
                                    </div>}

                                </FormControl>
                            </Grid> */}

                            {/* {this.state.AllSelectedUlb.length > 0 || this.state.ulbname != "" ? <Grid item xs={6}>
                                <FormControl>
                                    <label className="required" htmlFor="TreatmentFacilityName">Treatment Facility Name</label>
                                   
                                    <Select value={this.state.TfName}
                                        onChange={this.handleChange}
                                        name="TfName"
                                    >
                                        {!!this.state.tfOption && this.state.tfOption.map((tf) => {
                                            return (
                                                <MenuItem value={tf.TFId}>{tf.Name}</MenuItem>
                                            )
                                        }
                                        )}
                                    </Select>
                                        <div style={{ fontSize: 12, color: "red", fontFamily: "'Open Sans', sans-serif", marginTop: "1%" }}>{this.state.TfNameErr}</div>

                    

                                </FormControl>
                            </Grid> : ""
                            } */}

                            {/* <div className="ulb_listing " >
                                <TableContainer component={Paper} style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                                    <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>

                                        <TableHead >
                                            <TableRow >
                                                <TableCell key={1} className={"white-space"}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'start',
                                                        whiteSpace: 'break-spaces',
                                                        height: '3em'
                                                    }}>
                                                        ULB
                                                    </div>
                                                </TableCell>
                                                <TableCell key={2} className={"white-space"}>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'start',
                                                        whiteSpace: 'break-spaces',
                                                        height: '3em'
                                                    }}>
                                                        Treatment Facility Name
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.selectedTable.map((item) => {

                                                if (!!item.ulb) {
                                                    return <TableRow key={1}>

                                                        <TableCell key={1}>
                                                            {item.ulb}
                                                        </TableCell>
                                                        <TableCell key={1}>
                                                            {item.tf}
                                                        </TableCell>
                                                    </TableRow>
                                                }

                                            })}
                                           
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div> */}


                            <Grid item xs={6}>
                                <FormControl>
                                    <label htmlFor="statusType" >{t("status")}</label>
                                    <TextField id="select" name="statusType" value={this.state.StatusValue} onChange={this.handlChangeStatus} select>
                                        <MenuItem value={false}>{'Active'}</MenuItem>
                                        <MenuItem value={true}>{'In Active'}</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <div className="create_ulb_buttons">
                                    <Link style={{ textDecoration: "none", color: "#3dab35" }} to="/cluster-management"><Button className="login_submit" variant="outlined" color="primary">{t("cancel")}</Button></Link>
                                    <Button className="login_submit" variant="contained" color="primary" onClick={this.handleSubmit}>{this.state.typeId == "" ? t("save") : t("saveChange") }</Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (state, props) => {

    return {
        props: props,
        token: state.auth.token
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }

}

export default connect(mapStateToProps, mapDispatchToProps) (withTranslation()(ClusterForm))